import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useIsDesktop } from '../../hooks/useIsDesktop';
import { DRAWER_WIDTH } from '../../lib/navConfig';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';

const FocusLayout: React.FC = () => {
  const isDesktop = useIsDesktop();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((open) => !open);
  };

  const handleMobileClose = () => {
    setMobileOpen(false);
  };

  return (
    <div className="flex min-h-dvh flex-col bg-muted">
      <Navbar
        variant="focus"
        onDrawerToggle={handleDrawerToggle}
        drawerOpen={isDesktop || mobileOpen}
      />
      <div className="mt-16 flex h-[calc(100dvh-4rem)] min-h-0 overflow-hidden">
        <Sidebar
          mobileOpen={isDesktop || mobileOpen}
          onMobileClose={handleMobileClose}
          isDesktop={isDesktop}
        />
        <main
          className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden transition-all"
          style={{
            width: isDesktop ? `calc(100% - ${DRAWER_WIDTH}px)` : '100%',
            marginLeft: isDesktop ? DRAWER_WIDTH : 0,
          }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default FocusLayout;
